import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { SelfServeNodeLevels } from "../types";
import { buildNodeLevelPropName } from "../utils/buildNodeLevelPropName";
import { setSelectedNodeToLocalStorage } from "../utils/localStorage";
import { useSelfServeContextStore } from "./SelfServeContext";
export var useNodeSetter = function useNodeSetter() {
  var _useSelfServeContextS = useSelfServeContextStore([]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 2),
    setSelfServeContextStore = _useSelfServeContextS2[1];
  var setters = {};
  var _iterator = _createForOfIteratorHelper(SelfServeNodeLevels),
    _step;
  try {
    var _loop = function _loop() {
      var level = _step.value;
      var setterName = "setLevel".concat(level, "Node");
      setters[setterName] = function (node) {
        var nodeLevelProp = buildNodeLevelPropName(level);
        var selectedNode = _defineProperty({}, nodeLevelProp, node);
        setSelectedNodeAndResetNodesAbove(level, setSelfServeContextStore, selectedNode);
        setSelectedNodeToLocalStorage(level, node.id);
      };
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return setters;
};
export var setSelectedNodeAndResetNodesAbove = function setSelectedNodeAndResetNodesAbove(level, setSelfServeContextStore, selectedNode) {
  var resetNodes = {};
  for (var levelAbove = level + 1; levelAbove <= SelfServeNodeLevels.length; levelAbove++) {
    var nodeLevelProp = buildNodeLevelPropName(levelAbove);
    resetNodes = _objectSpread(_objectSpread({}, resetNodes), {}, _defineProperty({}, nodeLevelProp, undefined));
  }
  setSelfServeContextStore(_objectSpread(_objectSpread({}, resetNodes), selectedNode));
};